import React from 'react';
import { motion } from 'framer-motion';
import { PODCAST } from '../../data/content';
import { LineRevealOnView, Reveal } from './Reveal';

export const Podcast = () => (
  <section id="podcast" className="bg-teal text-cream scroll-mt-20 overflow-hidden">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-10 md:py-14">
      <div className="grid grid-cols-12 gap-y-10">
        <div className="col-span-12 md:col-span-3">
          <Reveal>
            <span className="text-xs tracking-[0.3em] uppercase text-cream/50 font-semibold">
              {PODCAST.overline}
            </span>
          </Reveal>
        </div>

        <div className="col-span-12 md:col-span-9">
          <LineRevealOnView
            lines={['THE CONVERSATIONS WE', 'WISH WE HAD EARLIER.']}
            lineClassName="font-serif uppercase text-cream text-4xl sm:text-5xl lg:text-6xl leading-[1.04] tracking-[-0.01em]"
            stagger={0.12}
          />

          <div className="mt-8 md:mt-9 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">
            <div className="lg:col-span-6 space-y-4">
              <Reveal>
                <p className="font-serif italic text-2xl md:text-3xl text-cream/90">
                  {PODCAST.name}
                </p>
              </Reveal>
              {PODCAST.lines.map((line, i) => (
                <Reveal key={i} delay={0.05 * i}>
                  <p
                    className={`font-light leading-relaxed ${
                      i === 0 ? 'text-lg md:text-xl text-cream' : 'text-base md:text-lg text-cream/70'
                    }`}
                  >
                    {line}
                  </p>
                </Reveal>
              ))}
              <Reveal delay={0.1}>
                <a
                  data-testid="listen-podcast"
                  href={PODCAST.link}
                  target="_blank"
                  rel="noreferrer"
                  className="group mt-4 inline-flex items-center gap-5 border border-cream/30 pl-7 pr-3 py-3 hover:border-cream transition-colors duration-500"
                >
                  <span className="text-xs tracking-[0.22em] uppercase font-medium">
                    {PODCAST.cta}
                  </span>
                  <span className="grid place-items-center w-11 h-11 rounded-full bg-cream text-teal transition-transform duration-500 group-hover:scale-105">
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="currentColor">
                      <path d="M0 0L12 7L0 14V0Z" />
                    </svg>
                  </span>
                </a>
              </Reveal>
            </div>

            <div className="lg:col-span-6">
              <Reveal delay={0.1}>
                <div className="relative overflow-hidden aspect-[4/5] w-full border border-cream/10">
                  <img
                    src={PODCAST.image}
                    alt="The Unscene Podcast"
                    className="editorial-img absolute inset-0 w-full h-full object-cover object-top"
                  />
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
